import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { default as DownloadableImage } from '../Image/downloadable';
import './posts.scss';

export class Post extends React.Component {
  constructor(props) {
    super(props);

  }

  copyCodeToClipboard = () => {
    this.textArea.select();
    document.execCommand("copy");
  }

  render() {
    const { title, description, items, hasAttachment, onClick } = this.props;
    const size = 3;
    return (
      <div className="posts">
        <div className={'element-box-tp'}>
          <div className="post-box">
            <div className="post-content">
              <div className="post-text">
                <span className={'badge badge-primary float-right '}
                      title={'Clicca per copiare'}
                      onClick={() => this.copyCodeToClipboard()}
                      id={'MarketingCopyPost'}
                      style={{cursor: 'pointer', fontWeight: 600}}
                >
                <i className={'fa fa-copy icon'}/>
                {' Copia'}
                </span>
                <h6>{title}</h6>
                {description}
                <textarea
                  style={{height: 0, width:0, overflow:'hidden', opacity: 0,}}
                  ref={(textarea) => this.textArea = textarea}
                  value={description}
                  readOnly={true}
                />
              </div>
              <div className="post-foot">
                <Row className={'no-gutters'}>
                  {
                    items.map(
                      (item, key) =>
                      <Col key={key} md={size}>
                        <DownloadableImage  src={item.image} binary={item.image_binary} name={item.image_name}/>
                      </Col>
                    )
                  }
                </Row>
              </div>
              {
                hasAttachment &&
                <Row className={'no-gutters'}>
                  <Col md={12}>
                    <button
                      className="btn btn-outline-primary btn-sm float-right"
                      type="button"
                      id={'MarketingPostDownload'}
                      onClick={onClick}
                    >
                      {'Scarica come allegato'}
                    </button>
                  </Col>
                </Row>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Post.defaultProps = {
  items: [],
  title: '',
  onClick: () => null,
  hasAttachment: false,
};

Post.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  items: PropTypes.array,
  onClick: PropTypes.func,
  hasAttachment: PropTypes.bool,
};

export default Post;
